import {InjectionToken} from '@angular/core'
import { Environment } from 'src/types/environment';
 
export const ENV = new InjectionToken<Environment>('env');